import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Extracts the provider name from a model ID in the format "provider:model"
 * @param id The model ID string (e.g., "openai:gpt-4o", "anthropic:claude-3")
 * @returns The provider name if found, undefined otherwise
 */
export function getProviderFromModelId(id: string): string | undefined {
  const colonIndex = id.indexOf(":");
  return colonIndex > 0 ? id.substring(0, colonIndex) : undefined;
}
